import * as PIXI from 'pixi.js';

import NativeMediaControls from '../utils/NativeMediaControls';
import BackgroundMedia from './BackgroundMedia';

export default class VideoMedia extends BackgroundMedia {
  static getVideoFrame;

  static setGetVideoFrame(callback) {
    this.getVideoFrame = callback;
  }

  constructor(model, app, video) {
    const sprite = PIXI.Sprite.from(video, {resourceOptions: {autoPlay: false}});
    super(model, app, sprite);

    this.video = video;
    this.videoControls = new NativeMediaControls(video);
    this.playbackVolume = video.volume ?? 1;

    this.video.addEventListener('seeked', this.updateTexture);
  }

  destroy() {
    super.destroy();
    this.video.removeEventListener('seeked', this.updateTexture);
  }

  updateModel(model) {
    this.model = model;
    this.trimStart = model.trimStart;
    super.updateModel(model);
    if (this.video) {
      const modelVolumeSet = model.volume || model.volume === 0;

      if (modelVolumeSet && model.volume !== this.playbackVolume) {
        this.setPlaybackVolume(model.volume);
      }
    }
  }

  play() {
    this.videoControls.play();
  }

  pause() {
    this.videoControls.pause();
  }

  mute() {
    this.videoControls.mute();
  }

  setPlaybackVolume(volume) {
    this.playbackVolume = volume;
    this.videoControls.setPlaybackVolume(volume);
  }

  unmute() {
    this.videoControls.unmute();
  }

  // TODO: async/await may later behavior of seeking in the browser
  async seek(timestamp) {
    const seekTo = timestamp + this.trimStart;
    const seeked = await this.videoControls.seek(seekTo);

    // Currently only used in Node.js
    if (VideoMedia.getVideoFrame) {
      await this._seekVideoFrame(seekTo);
    }

    return seeked;
  }

  async _seekVideoFrame(timestamp) {
    this.sprite.texture = await PIXI.Texture.from(
      await VideoMedia.getVideoFrame(timestamp, this.video.src, this.id)
    );
  }

  updateTexture = () => {
    if (!this.destroyed) {
      this.sprite.texture.update();
    }
  };
}
